import { render } from "./CategoryFilters.vue?vue&type=template&id=76c5a84c&scoped=true"
import script from "./CategoryFilters.vue?vue&type=script&lang=js"
export * from "./CategoryFilters.vue?vue&type=script&lang=js"

import "./CategoryFilters.vue?vue&type=style&index=0&id=76c5a84c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c5a84c"]])

export default __exports__